import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config";
import "./SpssPage.css";

function SpssPage() {
  const [file, setFile] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleCsvFileChange = (e) => {
    setCsvFile(e.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (!file) return alert("Please select an SPSS file to upload");

    const formData = new FormData();
    formData.append("spssFile", file);
    setIsLoading(true);

    try {
      const response = await axios.post(`${config.API_BASE_URL}/upload-spss`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setMessage(response.data.message || "File uploaded successfully!");
      alert("File uploaded successfully!");
    } catch (error) {
      setMessage("File upload failed. Please try again.");
      console.error(error.response ? error.response.data : error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCsvUpload = async () => {
    if (!csvFile) return alert("Please select a CSV file to upload");

    const formData = new FormData();
    formData.append("csvFile", csvFile);
    setIsLoading(true);
    console.log([...formData]); 
    try {
      const response = await axios.post(`${config.API_BASE_URL}/upload-csv`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setMessage(response.data.message || "CSV file uploaded successfully!");
      alert("CSV file uploaded successfully!");
    } catch (error) {
      setMessage("CSV upload failed. Please try again.");
      console.error(error.response ? error.response.data : error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const goBack = () => {
    navigate("/dashboards");
  };

  return (
    <div className="upload-container">
      <button onClick={goBack} className="back-button">&#8592; Back</button>
      <h2 className="upload-title">Upload Files</h2>

      <input type="file" accept=".sav" onChange={handleFileChange} className="file-input" />
      <button onClick={handleFileUpload} className="filter-button" disabled={!file || isLoading}>
        {isLoading ? "Uploading..." : "Upload SPSS"}
      </button>

      <input type="file" accept=".csv" onChange={handleCsvFileChange} className="file-input" />
      <button onClick={handleCsvUpload} className="filter-button" disabled={!csvFile || isLoading}>
        {isLoading ? "Uploading..." : "Upload CSV for survey Questons only"}
      </button>

      {message && <p style={{ textAlign: "center", color: "#007bff" }}>{message}</p>}
    </div>
  );
}

export default SpssPage;
